import i18next from 'i18next';
import { toast } from 'react-toastify';

import {
  getCreateFileMutationOptions,
} from '@vlabs/api/point-api/client';

import { queryClient } from '@vlabs/api';

export const uploadCardAttachments = async ({
  cardId,
  attachments,
}: {
  cardId: string;
  attachments: File[];
}): Promise<void> => {
  try {
    await Promise.all(
      attachments.map(async (file) => queryClient.mutateAsync(getCreateFileMutationOptions(queryClient), {
        data: file,
        params: {
          card_id: cardId,
          mimetype: file.type,
          filename: file.name,
        },
      })),
    );
  } catch {
    toast.error(i18next.t('features:createCard.create_card_modal.errors.file'));
  }
};
